import { render } from "@/components/pages/dataRecollection/obdReadinessStatus/obdReadinessStatusPage.html?vue&type=template&id=1a4530f1&external"
import script from "@/components/pages/dataRecollection/obdReadinessStatus/obdReadinessStatusPage.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/obdReadinessStatus/obdReadinessStatusPage.js?vue&type=script&lang=js&external"

import "@/components/pages/dataRecollection/obdReadinessStatus/obdReadinessStatusPage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__